import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Mission", href: "#mission" },
  { label: "Formats", href: "#products" },
  { label: "Shields", href: "#shields" },
  { label: "Engine", href: "#engine" },
  { label: "Networks", href: "#networks" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src="https://customer-assets.emergentagent.com/job_landing-builder-270/artifacts/g0s0yuk5_LuniPin%20%282%29.png"
            alt="Lunipin"
            className="h-8 md:h-9 w-auto object-contain"
          />
          <span className="font-mono text-[10px] text-neutral-500 hidden md:inline">
            //INTEL_SIM
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#pilot"
            data-testid="nav-cta-pilot"
            className="hidden md:inline-flex items-center gap-2 bg-[#dc2626] hover:bg-[#991b1b] px-5 py-2.5 font-mono text-xs uppercase tracking-[0.2em] font-semibold transition-all hover:translate-y-[-1px] hover:shadow-[0_8px_24px_rgba(220,38,38,0.4)]"
          >
            <span className="w-1.5 h-1.5 bg-white animate-pulse" />
            Start Pilot
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            className="lg:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="font-mono text-sm uppercase tracking-[0.2em] text-neutral-300 hover:text-white"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
